module.exports = __webpack_public_path__ + "static/media/apartment17.e29e263a.jpg";